import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_MAIN_APP_SENTRY_DSN,

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  // CI sets VITE_SENTRY_ENVIRONMENT from TF_VAR_env; local dev falls back to Vite mode
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,

  integrations: [],
});
